import { cn } from '../../lib/utils';
import { formatCampaignBudget, formatCampaignBudgetCompact, type CampaignBudgetFields } from '../../lib/campaignBudget';
import { formatMoney, formatMoneyCompact } from '../../lib/formatMoney';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

const FOCUS = 'focus-visible:ring-ring rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-inset';

function WithExactHover({ compact, exact, className }: { compact: string; exact: string; className?: string }) {
  if (compact === exact) return <span className={className}>{compact}</span>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0} className={cn(FOCUS, className)}>
          {compact}
        </span>
      </TooltipTrigger>
      <TooltipContent data-clarity-mask="True">{exact}</TooltipContent>
    </Tooltip>
  );
}

interface CompactBudgetProps {
  amount: number;
  currency?: string | null;
  className?: string;
}

export function CompactBudget({ amount, currency, className }: CompactBudgetProps) {
  const money = { amount, currency: currency || 'INR' };
  return <WithExactHover compact={formatMoneyCompact(money)} exact={formatMoney(money)} className={className} />;
}

/** A campaign's budget as the Home subtitle shows it: compact, with the exact text on hover. */
export function CompactCampaignBudget({ campaign, className }: { campaign: CampaignBudgetFields; className?: string }) {
  return <WithExactHover compact={formatCampaignBudgetCompact(campaign)} exact={formatCampaignBudget(campaign)} className={className} />;
}
